import { render } from "./InvoiceGuide.vue?vue&type=template&id=d0704ac6&scoped=true"
import script from "./InvoiceGuide.vue?vue&type=script&lang=js"
export * from "./InvoiceGuide.vue?vue&type=script&lang=js"

import "./InvoiceGuide.vue?vue&type=style&index=0&id=d0704ac6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0704ac6"]])

export default __exports__